<div class="common-text-input__container"
  [id]="field.id">
  <div class="common-text-input__container-box"
    [ngClass]="{'common-text-input__container-box--error': field.error}"
    [attr.disabled]="field.noEditable?true:null"
    #containerFieldTime>
    <div class="common-text-input__block-header">
      <div class="common-text-input__label-no-cursor">
        <span class="common-text-input__text-label">{{fieldTypeTime.titleField}}</span>
        @if(field.required){
          <span class="common-tag__mandatory-text-asterisk">*</span>
        }
        <div class="common-text-input__block-buttons">
          @if (field.description) {
            <tooltip-info [description]="field.description"
            [field]="field"></tooltip-info>
          }
          @if (field.references?.length) {
            <tooltip-law [references]="field.references"
            [field]="field"></tooltip-law>
          }
          @if (field.relatedInfo?.length){
            <button class="common-button__icon-sm-noborder"
                pTooltip="{{'common.related-info'| afTranslate}}"
                tooltipPosition="top"
                (click)="openModalRelatedInfo($event)">
                <i class="lf-icon-search-text common-icon__md"></i>
            </button>
          }
          @if (field.inReport !== null && field.inReport !== undefined && !isLanding){
            <tooltip-in-report [inReport]="fieldTypeTime.inReport"></tooltip-in-report>
          }
        </div>
      </div>
      <div class="common-text-input__buttons-right-header">
        @if(!field.noEditable){
          <div class="common-text-input__buttons-right-header-container">
            <button class="common-button__icon-sm-noborder"
              (click)="toggleFilter($event)">
              <i class="lf-icon-clock common-icon__md"></i>
            </button>
            <p-overlayPanel
              [id]="'clockFieldDateOverlay-' + field.id"
              styleClass="common-date__overlay-time">
              <ng-template pTemplate="content">
                <time-picker ngbDropdownMenu
                  [hours]="fieldTypeTime.inputHour"
                  [minutes]="fieldTypeTime.inputMinute"
                  [field]="field"
                  (changeTime)="changeInTimePicker($event)">
                </time-picker>
              </ng-template>
            </p-overlayPanel>
          </div>
        }
      </div>
    </div>
    <div class="common-text-input__block-input"
      [ngClass]="{'common-text-input__block-input--with-value': (fieldTypeTime.inputMinute.length || fieldTypeTime.inputHour.length) && !field.noEditable}">
      <div class="common-date__input-time-container">
        <input class="common-date__input-time"
          [id]="'time-picker-hour-' + field.id"
          [(ngModel)]="fieldTypeTime.inputHour"
          [pKeyFilter]="'int'"
          placeholder="00"
          maxlength="2"
          autocomplete="off"
          [disabled]="field.noEditable"
          (input)="changeInField('Hour', $event)"
          (blur)="blurInputTime('Hour')"/>
        <span>:</span>
        <input class="common-date__input-time"
          [id]="'time-picker-minute-' + field.id"
          [(ngModel)]="fieldTypeTime.inputMinute"
          [pKeyFilter]="'int'"
          placeholder="00"
          maxlength="2"
          autocomplete="off"
          [disabled]="field.noEditable"
          (input)="changeInField('Minute', $event)"
          (blur)="blurInputTime('Minute')"/>
      </div>
      @if ((fieldTypeTime.inputMinute.length || fieldTypeTime.inputHour.length) && !field.noEditable) {
        <button class="common-text-input__icon-clean-input"
          (click)="resetInput()">
          <i class="lf-icon-close-thick common-icon__sm"></i>
        </button>
      }
    </div>
  </div>
  @if(field.error && field.blocker){
    <div class="common-text-input__mandatory-tag">
      <i class="lf-icon-warning common-icon__error-md"></i>
      <span [afTranslate]="'common.field-mandatory-blocking'">Campo obligatorio</span>
    </div>
  }
  @if(field.error){
    <div class="common-text-input__mandatory-tag">
      @if(field.blocker){
        <i class="lf-icon-warning common-icon__error-md"></i>
      }
      @if (field.errorText) {
        <span>{{field.errorText}}</span>
      }@else {
        <span [afTranslate]="field.blocker?'common.field-mandatory-blocking':'common.field-mandatory'">Campo obligatorio</span>
      }
    </div>
  }
</div>
